import { render, staticRenderFns } from "./doc_viewer.vue?vue&type=template&id=6987b2fa&scoped=true"
import script from "./doc_viewer.vue?vue&type=script&lang=js"
export * from "./doc_viewer.vue?vue&type=script&lang=js"
import style0 from "./doc_viewer.vue?vue&type=style&index=0&id=6987b2fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6987b2fa",
  null
  
)

export default component.exports